// Painel Super Master > Aplicativo (pedido 2026-09-08) — histórico de
// versões do APK enviadas. GET é público (mesmo motivo de
// gpsdrive-notification-sounds.service.ts: não expõe nada sensível e pode
// um dia ser lido pelo próprio app Android pra checar atualização), por
// isso usa gpsDriveGet e não o cliente da plataforma. Upload/remoção são
// exclusivos do Super Master (platformUploadFileWithFields/platformDelete).
import { gpsDriveGet } from "@/lib/api/gpsdrive-client";
import { platformDelete, platformGet, platformPut, platformUploadFileWithFields } from "@/lib/api/gpsdrive-platform-client";

export interface AppReleaseEntry {
  id: string;
  version: string;
  url: string;
  fileName: string;
  fileSize: number;
  createdAt: string;
}

// .ipa/.zip/.aab (projeto e IPA do iOS, bundle da Play Store — 2026-10-02):
// o navegador declara tipos como application/zip ou application/x-itunes-ipa,
// que o backend recusa — ele só aceita o tipo do APK ou octet-stream e confere
// o conteúdo pela assinatura de ZIP (todos esses formatos são ZIP). O nome
// do arquivo é mantido.
function asOctetStream(file: File): File {
  if (file.name.toLowerCase().endsWith(".apk")) return file;
  return new File([file], file.name, { type: "application/octet-stream" });
}

export const gpsDriveAppReleasesService = {
  list: () => gpsDriveGet<AppReleaseEntry[]>("/api/v1/app-releases"),
  upload: (version: string, file: File) =>
    platformUploadFileWithFields<AppReleaseEntry>("/api/v1/app-releases", asOctetStream(file), { version }),
  remove: (id: string) => platformDelete(`/api/v1/app-releases/${id}`),
};

// Aviso "atualize o app na loja" (2026-10-21) — ver
// gpsdrive-backend src/app-releases/app-store-versions.controller.ts.
export interface AppStoreVersion {
  id: string;
  appId: string;
  platform: "android" | "ios";
  latestBuild: number;
  enabled: boolean;
  storeUrl: string | null;
  message: string;
}

export interface PublicAppVersion {
  enabled: boolean;
  latestBuild?: number;
  storeUrl?: string | null;
  message?: string;
}

export const gpsDriveAppStoreVersionsService = {
  list: () => platformGet<AppStoreVersion[]>("/api/v1/app-store-versions"),
  save: (input: Omit<AppStoreVersion, "id">) => platformPut<AppStoreVersion>("/api/v1/app-store-versions", input),
  // build vai junto só pra diagnóstico (aparece no log do nginx).
  publicVersion: (appId: string, build?: string) =>
    gpsDriveGet<PublicAppVersion>(
      `/api/v1/public/app-version?appId=${encodeURIComponent(appId)}${build ? `&build=${encodeURIComponent(build)}` : ""}`,
    ),
};
